import React from 'react'
import styled from 'styled-components'

import { LoadingPlaceholder } from '@sketch/components'

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1;
`

const StyledMessageContainer = styled.div`
  position: absolute;
  margin-top: 64px;
`

type LoadingStateProps = {
  message?: string
}

const LoadingState = ({ message }: LoadingStateProps) => (
  <LoadingWrapper>
    <LoadingPlaceholder size="64px" />
    {message && <StyledMessageContainer>{message}</StyledMessageContainer>}
  </LoadingWrapper>
)

export default LoadingState
